import { render, staticRenderFns } from "./OptOutNotification.vue?vue&type=template&id=29af353c&scoped=true&"
import script from "./OptOutNotification.vue?vue&type=script&lang=js&"
export * from "./OptOutNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29af353c",
  null
  
)

export default component.exports